import React, {useRef} from 'react';
import {useParams} from 'react-router-dom';
import {VerdocsEndpoint} from '@verdocs/js-sdk';
import {VerdocsSign} from '@verdocs/web-sdk-react';
import {postErrorToHost, postToHost, useHostResize} from './HostMessages';
import {FlexFill} from '../../Components';
import {CONFIG} from '../../config';

export const Sign: React.FC = () => {
  const {id = '', role = '', code = ''} = useParams();
  const endpoint = useRef(new VerdocsEndpoint({sessionType: 'signing', baseURL: CONFIG.API_URL}));
  const signer = {envelope_id: id, role_name: role};
  useHostResize('sign');

  return (
    <div className="flex flex-col inset-0 z-50 h-full absolute overscroll-y-auto bg-[#f6f8fa]">
      <VerdocsSign
        endpoint={endpoint.current}
        envelopeId={id}
        roleId={role}
        inviteCode={code}
        onEnvelopeLoaded={() => postToHost('sign', 'loaded', signer)}
        onEnvelopeUpdated={(e: any) => postToHost('sign', e.detail.event, signer)}
        onSdkError={(e: any) => postErrorToHost('sign', e, signer)}
      />

      <FlexFill />
    </div>
  );
};
